/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TechnicalVisitFormsAliases {
  AUTOCOMPLETE_MENU_MOBILE = 'autocomplete-menu-mobile',
  BREADCRUMB_ACCREDITATION = 'breadcrumb-accreditation',
  BUTTON_FINISH = 'button-finish',
  CARD_FILES = 'card-files',
  CARD_HISTORIES = 'card-histories',
  CONTEXTUAL_BAR = 'contextual-bar',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_ATTACHMENTS = 'deck-attachments',
  DECK_FORMS = 'deck-forms',
  FETCH_ATTACHMENTS = 'fetch-attachments',
  FETCH_FORMS = 'fetch-forms',
  FETCH_MENU_MOBILE = 'fetch-menu-mobile',
  FETCH_QUESTIONS = 'fetch-questions',
  FIELD_0 = 'field-0',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_GROUP = 'field-group',
  FIELD_IMAGE = 'field-image',
  FIELD_OBS = 'field-obs',
  FIELD_UPLOADER = 'field-uploader',
  FILE_UPLOADER = 'file-uploader',
  FORM_FILES = 'form-files',
  FORM_MENU_MOBILE = 'form-menu-mobile',
  FORM_MESSAGE = 'form-message',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  HPMS_FORM_TECHNICAL_VISIT = 'hpms-form-technical-visit',
  IMAGE_0 = 'image-0',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_2 = 'layout-2',
  LAYOUT_3 = 'layout-3',
  MAPPER_0 = 'mapper-0',
  MODAL_REFUSE = 'modal-refuse',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_ADITIONAL = 'panel-aditional',
  PANEL_APPOINTMENT_DETAILS = 'panel-appointment-details',
  PANEL_BUTTON = 'panel-button',
  PANEL_FILES = 'panel-files',
  PANEL_MOBILE = 'panel-mobile',
  PANEL_MODAL = 'panel-modal',
  PANEL_QUESTIONS = 'panel-questions',
  PANEL_SENT = 'panel-sent',
  PANEL_SIDEBAR = 'panel-sidebar',
  PANEL_TITLE_SIDEBAR = 'panel-title-sidebar',
  PANEL_UPLOAD = 'panel-upload',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_AREA_0 = 'text-area-0',
  TEXT_AREA_1 = 'text-area-1',
  TEXT_SUGESTED_DATES = 'text-sugested-dates',
  TEXT_TITLE = 'text-title',
  TEXT_TITLE_SENT = 'text-title-sent',
  TEXT_TITLE_SIDEBAR = 'text-title-sidebar',
}
export { TechnicalVisitFormsAliases };
